
import { defineComponent } from "vue";
export default defineComponent({
  name: "Template",
  setup() {
    return {};
  },
});
